
import { useEffect } from 'react';
import { FastingProtocol } from '@/types/fasting';

interface VisibilityChangeProps {
  isActive: boolean;
  isPaused: boolean;
  startTime: number | null;
  totalPauseDuration: number;
  selectedProtocol: FastingProtocol;
  setTimeElapsed: (value: number) => void;
}

export const useVisibilityChange = ({
  isActive,
  isPaused,
  startTime,
  totalPauseDuration,
  selectedProtocol,
  setTimeElapsed
}: VisibilityChangeProps) => {
  // Handle visibility change (e.g., tab switching)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible" && isActive && !isPaused && startTime) {
        console.log("[VisibilityChange] Tab became visible, syncing timer");
        const now = Date.now();
        const elapsedSeconds = Math.floor(((now - startTime) - totalPauseDuration) / 1000);
        const boundedElapsed = Math.max(0, Math.min(elapsedSeconds, selectedProtocol.durationHours * 60 * 60));
        
        console.log("[VisibilityChange] Calculated elapsed time:", {
          calculated: elapsedSeconds,
          bounded: boundedElapsed,
          startTime: new Date(startTime).toLocaleString()
        });
        
        setTimeElapsed(boundedElapsed);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [isActive, isPaused, startTime, totalPauseDuration, selectedProtocol, setTimeElapsed]);
};
